import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgWarning = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m25.9 20.572-9.565-16.61a2.708 2.708 0 0 0-4.67 0L2.1 20.572a2.571 2.571 0 0 0 0 2.595A2.664 2.664 0 0 0 4.435 24.5h19.13a2.664 2.664 0 0 0 2.333-1.333 2.572 2.572 0 0 0 .002-2.595Zm-1.517 1.719a.93.93 0 0 1-.818.459H4.435a.93.93 0 0 1-.818-.46.83.83 0 0 1 0-.844l9.565-16.61a.957.957 0 0 1 1.64 0l9.565 16.61a.83.83 0 0 1-.004.845ZM13.125 15.75v-4.375a.875.875 0 1 1 1.75 0v4.375a.875.875 0 1 1-1.75 0Zm2.188 3.938a1.313 1.313 0 1 1-2.626 0 1.313 1.313 0 0 1 2.626 0Z" />
  </svg>
);
export default SvgWarning;
